import {Pipe, PipeTransform} from '@angular/core';
import {AssetClassification, AssetType} from "@services";

@Pipe({
    name: 'assetClassification',
    standalone: true
})
export class AssetClassificationPipe implements PipeTransform {
    transform(value: AssetType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case AssetClassification.Land: return "Land";
            case AssetClassification.Building: return "Building";
            case AssetClassification.MachineriesEquipment: return "Machineries / Equipment";
            case AssetClassification.OfficeEquipment: return "Office Equipment";
            case AssetClassification.FurnitureAndFixtures: return "Furniture and Fixtures";
            case AssetClassification.Software: return "Software";
            default: return value;
        }
    }
}

